import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import MiniCarousel from "./MiniCarousel";

const cards = [
	{
		id: 1,
		title: "Market Analysis",
		description:
			"Assess market trends, volume, and momentum to make informed trading decisions.",
	},
	// {
	// 	id: 2,
	// 	title: "Risk Management",
	// 	description:
	// 		"Implement stop-loss and take-profit strategies to protect your investments.",
	// },
	// {
	// 	id: 3,
	// 	title: "Technical Indicators",
	// 	description:
	// 		"Use tools like RSI, MACD, and Bollinger Bands to identify entry and exit points.",
	// },
	// {
	// 	id: 4,
	// 	title: "Diversification",
	// 	description:
	// 		"Spread investments across different cryptocurrencies to minimize risk.",
	// },
];

// const cards = [
//   {
//     id: 1,
//     title: 'Plants',
//     description: 'Plants are essential for all life.',
//   },
//   {
//     id: 2,
//     title: 'Animals',
//     description: 'Animals are a part of nature.',
//   },
//   {
//     id: 3,
//     title: 'Humans',
//     description: 'Humans depend on plants and animals for survival.',
//   },
// ];

function SelectActionCard() {
	const [selectedCard, setSelectedCard] = React.useState(0);
	return (
		<Box
			sx={{
				width: "90%",
				display: "grid",
				gridTemplateColumns: "2fr 2fr",

				// gridTemplateColumns: "repeat(auto-fill, minmax(min(200px, 100%), 1fr))",
				gap: 2,

				// bgcolor: "red",
			}}>
			<MiniCarousel />
			{cards.map((card, index) => (
				<Card>
					<CardActionArea
						onClick={() => setSelectedCard(index)}
						data-active={selectedCard === index ? "" : undefined}
						sx={{
							height: "100%",
							"&[data-active]": {
								backgroundColor: "action.selected",
								"&:hover": {
									backgroundColor: "action.selectedHover",
								},
							},
						}}>
						<CardContent sx={{ height: "100%" }}>
							<Typography
								variant="h5"
								component="div"
								sx={{ fontSize: "0.9rem" }}>
								{card.title}
							</Typography>
							<Typography variant="body2" color="text.secondary">
								{card.description}
							</Typography>
						</CardContent>
					</CardActionArea>
				</Card>
			))}
		</Box>
	);
}

export default SelectActionCard;
